export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.12-0859.48",
  commitId: "2c9366fe84634538945bb8da1c71aa688d24a5e0",
  commitTime: "2026-05-12T08:59:48.000Z",
});
